import templateUrl from './products-list.component.html'

export const ProductsListComponent = {
    controller: ProductsListController,
    controllerAs: "vm",
    templateUrl
};

function ProductsListController($uibModal, utilityService, productsService) {
    'ngInject';
    const vm = this;

    vm.$onInit = activate;

    vm.columns;
    vm.sortColumns = [{ field: "EffectiveDate", dir: -1 }]; // Default
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass
    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.onSetSort = onSetSort;
    vm.sortProducts = sortProducts;
    vm.products = [];
    vm.prestineproducts = [];
    vm.onEdit = onEdit;
    vm.filters = {};
    vm.filterProduct = filterProduct;
    vm.onDelete = onDelete;
    function activate() {
        vm.columns = [
            {
                title: "Product Line",
                field: "ProductLineName",
                sortable: true
            },
            {
                title: "Code #",
                field: "productCode",
                sortable: true
            },

            {
                title: "Name",
                field: "Name",
                sortable: true
            },
            {
                title: "Description",
                field: "Description",
                sortable: true
            },
            {
                title: "Division",
                field: "DivisionName",
                sortable: true
            },

            {
                title: "Actions",
                field: "Actions",
                sortable: false
            }
        ];

        loadProducts();
    }
    function loadProducts() {
        utilityService.showLoading();
        productsService.retrieveProducts()
            .then(function (products) {
                vm.products = products;
            }).catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                if (vm.products) {
                    if ((vm.pageNumber - 1) * vm.pageSize >= vm.products.length) {
                        vm.pageNumber = 1;
                    }
                }
                utilityService.hideLoading();
            });
    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField.field;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField.field, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        vm.sortProducts(vm.products);

    }

    function sortProducts(products) {

        return products.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }
    function filterProduct(product) {
        return (!vm.filters.ProductLineName
            || utilityService.containsInvariant(product.ProductLineName, vm.filters.ProductLineName))
            && (!vm.filters.ProductCode
                || utilityService.containsInvariant(product.ProductCode, vm.filters.ProductCode))
            && (!vm.filters.Name || utilityService.containsInvariant(product.Name, vm.filters.Name))
            && (!vm.filters.Description
                || utilityService.containsInvariant(product.Description, vm.filters.Description))
            && (!vm.filters.DivisionName
                || utilityService.containsInvariant(product.DivisionName, vm.filters.DivisionName))
    }
    function onEdit(product) {
        $uibModal.open({
            template: /*html*/`
                <div class="modal-header"><h1>New Product</h1></div>
                <div class="modal-body">
                    <apex-edit-product product="vm.product"
                                       after-submit="vm.afterSubmit(product)"></apex-edit-product>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-plain float-right" ng-click="vm.close()">Close</button>
                </div>`,
            controller: function ($uibModalInstance, product) {
                'ngInject';
                this.product = !product ? null : product;

                this.afterSubmit = function (product) {
                    $uibModalInstance.close(product);
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                    loadProducts();
                };
            },
            controllerAs: "vm",
            resolve: {
                product: product

            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (product) {
            loadProducts();
        }).then(function () {
            utilityService.hideLoading();
        })
    }
    function onDelete(product) {
        if (confirm("Are you sure you want to delete the product ?")) {
            utilityService.showLoading();
            productsService.deleteProduct(product.ProductID)
                .then(function (products) {
                    loadProducts();
                }).catch(function (ex) {
                    alert("Delete failed: " + utilityService.getExceptionMessage(ex));
                    utilityService.hideLoading();
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }
}
